import { Navigate, Outlet } from "react-router";
import { trpc } from "../../lib/trpc";
import { Loader2 } from "lucide-react";

export function AdminGuard() {
  const { data: session, isLoading } = trpc.auth.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-zinc-50">
        <Loader2 className="h-8 w-8 animate-spin text-zinc-400" />
      </div>
    );
  }

  if (!session || session.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
